module.exports = __webpack_public_path__ + "img/Group_2398.c631a259.svg";